import React, { createContext, useContext, ReactNode } from 'react';

interface DashboardContextType {
  dashboardId: string | null;
  dashboardTitle?: string;
  dashboardScope?: string;
}

const DashboardContext = createContext<DashboardContextType | undefined>(
  undefined,
);

interface DashboardProviderProps {
  children: ReactNode;
  dashboardId: string;
  dashboardTitle?: string;
  dashboardScope?: string;
}

export const DashboardProvider: React.FC<DashboardProviderProps> = ({
  children,
  dashboardId,
  dashboardTitle,
  dashboardScope,
}) => {
  const value: DashboardContextType = {
    dashboardId,
    dashboardTitle,
    dashboardScope,
  };

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboardContext = (): DashboardContextType => {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    // Return a fallback object instead of throwing an error
    // This allows the hook to work even outside of a dashboard context
    return {
      dashboardId: null,
      dashboardTitle: undefined,
      dashboardScope: undefined,
    };
  }
  return context;
};

// Helper hook that gets just the dashboard ID
export const useDashboardId = (): string | null => {
  const { dashboardId } = useDashboardContext();
  return dashboardId;
};
